import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ServiceFeedback from './components/ServiceFeedback';
import FeedbackThankYou from './components/FeedbackThankYou';
import CustomerProfile from './components/CustomerProfile';
import { CustomerProvider } from './contexts/customer-context';
import CustomerWelcomePage from './components/CustomerWelcomePage';
import CustomerLogin from './components/CustomerLogin';
import CustomerSignup from './components/ConsumerSignup';
import ChangePassword from './components/ChangePassword';
import Header from './components/Header';
import { useCustomer } from './contexts/customer-context';
import ProtectedRoute from './components/ProtectedRoute';
import theme from './theme';

// Create a wrapper component that provides the navigate function to CustomerProvider
const CustomerProviderWrapper = ({ children }) => {
  const navigate = useNavigate();
  return <CustomerProvider navigate={navigate}>{children}</CustomerProvider>;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <CustomerProviderWrapper>
          <Routes>
            <Route path="/login" element={<CustomerLogin />} />
            <Route path="/signup" element={<CustomerSignup />} />
            <Route path="/feedback/:businessId" element={<ServiceFeedback />} />
            <Route path="/thank-you" element={<FeedbackThankYou />} />
            <Route path="/profile" element={<CustomerProfile />} />
            <Route path="/welcome" element={
              <ProtectedRoute>
                <CustomerWelcomePage />
              </ProtectedRoute>
            } />
            <Route path="/change-password" element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            } />
          </Routes>
        </CustomerProviderWrapper>
      </Router>
    </ThemeProvider>
  );
}

export default App;